import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";

import * as serviceWorker from "./serviceWorker";
import LoginLoading from "./app/LoginLoading";

// Font Loading
import "./index.css";

ReactDOM.render(
    <Router>
        <Provider store={store}>
            <Route path="/" component={LoginLoading} />
            <App />
        </Provider>
    </Router>,

    document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
